/** Static opener copy shown before the visitor sends their first message. */
export const CHAT_OPENING_MESSAGES = [
  "What do you want to do with B2B video?",
  "Let me ping B Ring, the owner. If you can wait a minute or two, he loves to grab the messages and respond in real time. In the meantime, please send your question and I'll do my best.",
];
